<template>
  <div class="table--wrap" ref="listTable">
    <p class="content__title">{{ $t('plan.period') }}</p>
    <ui-selectbox class="some-class" :value="duration" :items="durationList" :width="'175px'" :hideLabel="true"
      @input="onDurationChange" />
    <app-pagination class="jam-detail-pagination clearfix pagination"
                    :total="chargedJamCount"
                    :page.sync="page"
                    :limit="limit"
                    :pagingBlock="5"
                    :type="'jamList'"
                    :serviceType="serviceType"
                    :filterList="filterJamDetailList"
                    :filterPaymentList="filterPaymentList"
                    :dateRange="dateRange"
                    :jamValue="jamValue"
                    @onChangeDate="onChangeDate"
                    @onChangeJamFilter="onChangeJamFilter"
                    @onPagingOptionChange="onPagingOptionChange">
    </app-pagination>
    <data-table sortType="-regDate" :headers="chargeHeaders" @changeSort="changeSort">
      <template v-slot:colgroup>
        <colgroup>
          <col width="20%">
          <col width="20%">
          <col width="195px">
          <col width="20%">
          <col width="20%">
          <col width="20%">
          <col width="20%">
        </colgroup>
      </template>
      <template v-slot v-if="isLoaded">
        <tbody v-if="chargedJam.length > 0">
          <tr v-for="(item, index) in chargedJam" :key="index" :class="{'child': item.child, 'on': item.show, 'up': item.chargeShow, 'last': item.last}">
            <td class="data__date">
              <span>{{ item.regDate | dashDate }}</span>
            </td>
            <td class="data__provide " :class="{'child': item.child}" v-if="item.child && item.show">
                <span v-if="item.jamUseCount > 0">+{{ item.jamUseCount | thousand }}</span>
                <span v-else>{{ item.jamUseCount | thousand }}</span>
            </td>
            <td class="data__provide" v-else>
              <span v-if="item.chargeJam > 0 && (item.detail === state.MOVE_TO_BASKET || item.detail === state.PV_CHARGE)">{{ item.chargeJam | thousand }}</span>
              <span v-else-if="item.chargeJam > 0 && item.detail !== state.JAM_EXPIRED">+{{ item.chargeJam | thousand }}</span>
              <span v-else-if="item.detail === state.JAM_EXPIRED">-{{ item.chargeJam | thousand }}</span>
              <span v-else> {{ item.chargeJam | thousand }} </span>
            </td>
            <td class="data__date_expire expireDate has-detail" :class="{'child': item.child}" v-if="item.child && item.show ">
                {{ item.expireDate | dashDate  }}
            </td>
            <td class="data__date_expire expireDate has-detail" :class="{'has-detail': item.detailCount, 'non-detail': !item.detailCount}" v-else>
              {{ item.expireDate | dashDate  }}
              <template v-if="item.detailCount > 1">
                <span class="detail-count"> +{{item.detailCount}}</span>
                <i class="icon icon--toggle-slide16" :class="{'up': item.chargeShow}" @click="toggleCharge(item, $event)" ></i>
              </template>
            </td>
            <td class="data__date">
              <span>{{ getServiceTypeText(item.serviceType) }}</span>
            </td>
            <td class="data__total" v-if="item.child"></td>
            <td class="data__total" v-else>
              <span v-if="item.detail === state.MOVE_TO_BASKET">{{$t('plan.jam.jamState.MOVE_TO_BASKET')}}</span>
              <span v-else-if="item.detail === state.PV_CHARGE">{{$t('plan.jam.jamState.PV_CHARGE')}}</span>
              <span v-else-if="item.detail === state.JAM_REFUND">{{$t('plan.jam.jamState.JAM_REFUND')}}</span>
              <span v-else-if="item.detail === state.JAM_CHARGE">{{$t('plan.jam.jamState.JAM_CHARGE')}}</span>
              <span v-else-if="item.detail === state.JAM_EXPIRED">{{$t('plan.jam.jamState.JAM_EXPIRED')}}</span>
              <span v-else-if="item.detail === state.MOVE_TO_MY_JAM">{{$t('plan.jam.jamState.MOVE_TO_MY_JAM')}}</span>
              <span v-else-if="item.detail === state.BUY_REPORT_PREFIX">{{$t('plan.jam.jamState.BUY_REPORT_PREFIX')}}</span>
              <span v-else-if="item.detail === state.BUY_REPORT_INDEPTH">{{$t('plan.jam.jamState.BUY_REPORT_INDEPTH')}}</span>
              <span v-else-if="item.detail === state.BUY_REPORT_PERIOD">{{$t('plan.jam.jamState.BUY_REPORT_PERIOD')}}</span>
              <span v-else-if="item.detail === state.BUY_REPORT_SEGMENT">{{$t('plan.jam.jamState.BUY_REPORT_SEGMENT')}}</span>
              <span v-else-if="item.detail === state.BUY_REPORT_SCROLL">{{$t('plan.jam.jamState.BUY_REPORT_SCROLL')}}</span>
              <span v-else-if="item.detail === state.CANCEL_REPORT_PREFIX">{{$t('plan.jam.jamState.CANCEL_REPORT_PREFIX')}}</span>
              <span v-else-if="item.detail === state.CANCEL_REPORT_INDEPTH">{{$t('plan.jam.jamState.CANCEL_REPORT_INDEPTH')}}</span>
              <span v-else-if="item.detail === state.CANCEL_REPORT_PERIOD">{{$t('plan.jam.jamState.CANCEL_REPORT_PERIOD')}}</span>
              <span v-else-if="item.detail === state.CANCEL_REPORT_SEGMENT">{{$t('plan.jam.jamState.CANCEL_REPORT_SEGMENT')}}</span>
              <span v-else-if="item.detail === state.BUY_REPORT_DASHBOARD">{{$t('plan.jam.jamState.BUY_REPORT_DASHBOARD')}}</span>
              <span v-else-if="item.detail === state.BUY_REPORT_DASHBOARD_HELL">{{$t('plan.jam.jamState.BUY_REPORT_DASHBOARD_HELL')}}</span>
              <span v-else-if="item.detail === state.REWARD">{{$t('plan.jam.jamState.REWARD')}}</span>
            </td>
            <td class="data__total" v-if="item.child"></td>
            <td class="data__total" v-else>
              <span v-if="item.cardNumber === state.PAYMENT_4GRIT">{{$t('plan.jam.jamState.4grit')}}</span>
              <span v-else-if="item.cardNumber === state.PAYMENT_WIRE">{{$t('plan.jam.jamState.WIRE')}}</span>
              <span v-else-if="item.cardNumber === state.PAYMENT_CARD">{{$t('plan.jam.jamState.CARD')}}</span>
              <span v-else>-</span>

            </td>
            <td class="data__total_price" v-if="item.child"></td>
            <td class="data__total_price" v-else-if="item.detail === state.MOVE_TO_BASKET ||
             item.detail === state.MOVE_TO_MY_JAM ||
             item.detail === state.PV_CHARGE ||
             item.detail === state.JAM_EXPIRED ||
             item.detail === state.CANCEL_REPORT_PREFIX ||
             item.detail === state.CANCEL_REPORT_INDEPTH ||
             item.detail === state.CANCEL_REPORT_PERIOD ||
             item.detail === state.BUY_REPORT_INDEPTH ||
             item.detail === state.BUY_REPORT_PERIOD ||
             item.detail === state.BUY_REPORT_PREFIX">-</td>
            <td class="data__total_price" v-else>₩{{ item.price | thousand }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="no-list" colspan="7">
              {{ $t('plan.jam.noChargedJam') }}
            </td>
          </tr>
        </tbody>
      </template>
    </data-table>
  </div>
</template>
<script>
import UiSelectbox from '@/components/ui/UiSelectbox'
import AppPagination from '@/components/ui/AppPagination'
import DataTable from '@/components/ui/DataTable'
import { mapState } from 'vuex'
import { parse, startOfDay, addDays, addMonths, format } from 'date-fns'
import UiButton from '@/components/ui/UiButton.vue'
import ContentBox from '@/components/ui/ContentBox.vue'
import {
  JAM_LIST_STATE,
  JAM_PAYMENT_LIST_STATE,
  PAYMENT_LIST_STATE
} from '@/libs/constants'

export default {
  components: {
    ContentBox,
    UiButton,
    AppPagination,
    UiSelectbox,
    DataTable
  },
  props: [
    'sort',
    'chargedJam',
    'length',
    'isLoaded',
    'jamValue',
    'serviceType'
  ],
  data () {
    return {
      state: JAM_PAYMENT_LIST_STATE,
      searchParam: Object.values(JAM_PAYMENT_LIST_STATE),
      showFlip: false,
      showReceiptLayer: false,
      chargeHeaders: [
        {
          name: this.$t('plan.jam.jamChargeDate'),
          sortable: true,
          value: 'regDate'
        },
        {
          name: this.$t('plan.jam.chargedJam'),
          sortable: true,
          value: 'chargeJam'
        },
        {
          name: this.$t('plan.jam.jamExpiration'),
          sortable: true,
          value: 'expireDate'
          // alignLeft: true
        },
        {
          name: this.$t('plan.jam.service'),
          sortable: true,
          value: 'serviceType'
        },
        {
          name: this.$t('plan.jam.detail'),
          sortable: true,
          value: 'detail'
        },
        {
          name: this.$t('userInfo.billing.paymentDetail.paymentMethod'),
          sortable: true,
          value: 'cardNumber'
        },
        {
          name: this.$t('plan.jam.chargeAmount'),
          sortable: true,
          value: 'price'
        }
      ],
      duration: 0,
      durationList: [
        {
          value: 0,
          text: this.$t('common.all')
        },
        {
          value: 3,
          text: this.$t('common.recentMonths', { month: '3' })
        },
        {
          value: 6,
          text: this.$t('common.recentMonths', { month: '6' })
        },
        {
          value: 12,
          text: this.$t('common.recentMonths', { month: '12' })
        },
        {
          value: 24,
          text: this.$t('common.recentMonths', { month: '24' })
        }
      ],
      page: 1,
      limit: 30,
      dateRange: {
        startDate: null,
        endDate: null
      },
      filterJamDetailList: [],
      filterPaymentList: []
    }
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    chargedJamCount () {
      return this.length > 0 ? this.length : 0
    },
    selectedJamFilter () {
      let data = []
      this.filterJamDetailList.forEach(item => {
        if (item.key !== 'all' && item.value) {
          if (item.key === 'CANCEL_REPORT' || item.key === 'BUY_REPORT') {
            data = data.concat(item.detailValue)
          } else {
            data.push(item.key)
          }
        }
      })
      return data
    },
    selectedPaymentFilter () {
      const data = []
      this.filterPaymentList.forEach(item => {
        if (item.key !== 'all' && item.value) {
          data.push(item.key)
        }
      })
      return data
    }
  },
  methods: {
    getServiceTypeText (type) {
      if (type === 'ba') {
        return 'Journey Map'
      } else if (type === 'beusable') {
        return 'UX Heatmap'
      } else {
        return this.$t('common.etc')
      }
    },
    onChangeDate (startDate, endDate) {
      this.dateRange.startDate = startDate
      this.dateRange.endDate = endDate
    },
    onChangeJamFilter (filterJamDetail, filterPayment, dateRange, serviceType, jamValue) {
      this.filterJamDetailList = filterJamDetail
      this.filterPaymentList = filterPayment
      this.dateRange = { ...dateRange }
      const paging = {
        page: 1,
        limit: this.limit
      }
      this.page = 1

      this.$emit('setJamList', paging, dateRange, this.sort, this.selectedJamFilter, this.selectedPaymentFilter, serviceType, jamValue)
    },
    changeSort (value) {
      const paging = {
        page: this.page,
        limit: this.limit
      }
      this.$emit('setJamList', paging, this.dateRange, value, this.selectedJamFilter, this.selectedPaymentFilter)
    },
    toggleCharge (data, $event) {
      this.$emit('show', data)
    },
    onPagingOptionChange (page, limit) {
      this.page = page
      this.limit = limit
      this.onSetOptionList()
    },
    onDurationChange (duration) {
      const today = startOfDay(new Date())
      const minDate = addDays(startOfDay(parse(this.userData.regDate)), -1)
      const endDate = parse(today)
      let startDate = addMonths(today, -duration)
      if (duration === 0) {
        startDate = addDays(parse(this.userData.regDate), -1)
      }

      if (startDate < minDate) {
        startDate = parse(minDate)
      }

      this.duration = duration
      this.dateRange = {
        startDate: format(startDate, 'YYYY-MM-DD'),
        endDate: format(endDate, 'YYYY-MM-DD')
      }
      this.page = 1
      this.onSetOptionList()
    },
    onSetOptionList () {
      const paging = {
        page: this.page,
        limit: this.limit
      }
      const dateRange = this.dateRange
      this.$emit('setJamList', paging, dateRange, this.sort, this.selectedJamFilter, this.selectedPaymentFilter)
    }
  },
  created () {
    const filterJamDetailList = JAM_LIST_STATE
    this.filterJamDetailList.push({
      value: true,
      key: 'all',
      type: 'all'
    })
    for (let key in filterJamDetailList) {
      const jamDetail = filterJamDetailList[key]
      const data = {
        detailValue: jamDetail.value,
        value: true,
        key: key,
        type: jamDetail.type
      }
      this.filterJamDetailList.push(data)
    }

    const filterPaymentList = PAYMENT_LIST_STATE
    this.filterPaymentList.push({
      value: true,
      key: 'all'
    })
    for (let key in filterPaymentList) {
      const data = {
        value: true,
        key: filterPaymentList[key]
      }
      this.filterPaymentList.push(data)
    }
  }
}
</script>
<style lang="scss" scoped>
.icon--toggle-slide16 {
  top: 3px;
  position: relative;
  margin-left: 5px;
  width: 16px;
  height: 16px;
  background: url(../../../assets/img/icon_slide_toggle_size16.svg) no-repeat 0 0;
  cursor: pointer;
  pointer-events: visible;
  &.up {
    transform: rotate(180deg);
  }
}
.table--wrap {
  .dimmed {
    .receipt--wrap {
      @include positionXYcenter;
      text-align: center;
      padding: 30px;

      .title {
        text-align: left;
        font-size: 15px;
        font-weight: 500;
        color: #2f2f2f;
        margin-bottom: 25px;
      }

      .icon {
        position: absolute;
        top: 12px;
        right: 12px;
      }
    }
  }
  .jam-detail-pagination {
    float: right;
    width: auto;
    margin-bottom: 15px;
  }

  .content__title {
    font-size: 15px;
    font-weight: 500;
    color: #2f2f2f;
    display: inline-block;
    padding: 13px 0 20px 0;
    float: left;
  }

  .ui_select {
    float: left;
    margin-left: 20px;
  }

  /deep/ thead {
    font-size: 13px;
  }

  /deep/ tbody tr {
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
    &.child {
      display: none;
      &.on {
        display: table-row;
        border-top: 0 solid #eeeeee;
        border-bottom: none;
        & > td {
          height: 36px;
        }
        &.last td {
          padding-bottom: 7px;
        }
      }
    }

    &.up {
      border-bottom: none;
    }
  }
  /deep/ tbody tr td {
    height: 50px;
    font-size: 13px;
    line-height: 1.23;
    color: #2f2f2f;
    text-align: center;
    &.data__total_price {
      float: right;
      line-height: 50px;
      padding-right: 70px;
    }
    .detail-count {
      margin-left: 5px;
      display: inline-block;
      vertical-align: middle;
      background: #F0F0F0;
      border-radius: 10px;
      border: 1px #DDDDDD solid;
      font-size: 12px;
      padding: 4px 6px;
      transform: translateY(-1px);
      line-height: 1;
      color: #666666;
    }
    &.has-detail {
      padding-left: 58px;
    }
    &.non-detail {
      //padding-right: 75px;
    }
    &.child {
      color: #FF5B8C;
    }
    &.expireDate {
      text-align: left;
    }
  }

  /deep/ tbody tr .no-list{
    height: 199px;
    color: #767676;
    text-align: center;
  }
}
</style>
